import { render, staticRenderFns } from "./DriversDetails.vue?vue&type=template&id=c529cd44&"
import script from "./DriversDetails.vue?vue&type=script&lang=js&"
export * from "./DriversDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports